import Fuse from "fuse.js";
import type { DocsSearchEntry } from "./catalog";

export function createDocsSearch(entries: DocsSearchEntry[]) {
  return new Fuse(entries, {
    keys: [
      { name: "product", weight: 2 },
      { name: "title", weight: 2 },
      { name: "heading", weight: 3 },
      { name: "text", weight: 1 },
    ],
    threshold: 0.35,
    ignoreLocation: true,
    minMatchCharLength: 2,
    includeMatches: true,
  });
}
